export const tractorEditableColumns = [
  "SI",
  // "Market",
  "Remark",
  "Port_Of_Destination",
  "Container_Type",
  "Inspection",
  "Booking_Number",
  "Booking_Doc",
  "VSL_VOY",
  "final_destination",
  "Carrier",
  "Transporter",
  "ETD",
  "ETA",
  "Factory_In_Date",
  "Factory_Out_Date",
  "JD_Stuffing_Date",
  "Ground_Rent_Days",
  "Origin_Transit_Time",
  "Approx_container_detention",
  "Booking_Doc",
  "SI",
  "Remark",
  "Delete",
  "Date"
];

export const aggregateEditableColumns = [
  "Remark",
  // "Country",
  "Port_Of_Destination",
  "Container_Type",
  "Inspection",
  "Booking_Number",
  "Booking_Doc",
  "VSL_VOY",
  "final_destination",
  "Carrier",
  "Transporter",
  "ETD",
  "ETA",
  "Factory_In_Date",
  "Factory_Out_Date",
  "JD_Stuffing_Date",
  "Ground_Rent_Days",
  "Origin_Transit_Time",
  "Approx_container_detention",
  "Booking_Number",
  "Booking_Doc",
  "Remark",
  "Delete",
  "Date"
];

export const fiveMEditableColumns = [
  "SI",
  // "Market",
  "Remark",
  "Port_Of_Destination",
  "Container_Type",
  "Inspection",
  "Booking_Number",
  "Booking_Doc",
  "VSL_VOY",
  "final_destination",
  "Carrier",
  "Transporter",
  "ETD",
  "ETA",
  "Factory_In_Date",
  "Factory_Out_Date",
  "JD_Stuffing_Date",
  "Ground_Rent_Days",
  "Origin_Transit_Time",
  "Approx_container_detention",
  "Delete",
  "Date"
];

